<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12" *ngIf="!segmento.indicadorHabilitado && !detalle">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label for="producto">* {{ 'SEGMENTOSEMPLEADOS.LBL_NUMEROEMPLEADOS' | translate}}</label>
                <p-dropdown disableTab  id="producto" [options]="listaNumeroEmpleados" formControlName="idNumeroEmpleado"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="submitted && f.idNumeroEmpleado.errors">
                  <i class="fa fa-close"></i>{{ 'SEGMENTOSEMPLEADOS.LBL_NUMEROEMPLEADOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6 text-md-right text-lg-right text-center">
              <button class="p-button-datatables" pButton icon="fa fa-plus" label="{{ 'LBL_AGREGAR' | translate}}" type="submit"></button>
            </div>
          </div>
        </form>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carSegmentoProducto" #dt
                 [value]="segEmpleados" selectionMode="single" dataKey="idSegmentoActivo"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                  class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreNumeroEmpleado}}</td>
              <td class="text-center" *ngIf="!detalle">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_DESHABILITAR' | translate}}" pButton
                          (click)="disable(row)"  *ngIf="!segmento.indicadorHabilitado"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-12 md:col-12 lg:col-12"
           *ngIf="segmentoTemp!==undefined && segmentoTemp.segmentosEmpleadosList !== null && segmentoTemp.segmentosEmpleadosList.length>0">
        <hr>
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas"
                   [value]="segmentoTemp.segmentosEmpleadosList" selectionMode="single" dataKey="idSegmentoActivo"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th [pSortableColumn]="columns[0].field" [pSortableColumnDisabled]="!columns[0].sort"
                    class="text-center">
                  {{columns[0].header}}
                  <p-sortIcon [field]="columns[0].field" *ngIf="columns[0].sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.nombreNumeroEmpleado}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="empleados">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'BTN_NO' | translate}}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'BTN_SI' | translate}}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
